var _defs, _mask, _g, _g2, _mask2, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBanKharAvatar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "ban_khar_v7-a",
    cx: 112,
    cy: 112,
    r: 112
  }), /*#__PURE__*/React.createElement("filter", {
    id: "ban_khar_v7-b",
    width: "131.2%",
    height: "131.2%",
    x: "-15.6%",
    y: "-11.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 2,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.264662591 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-d",
    points: "0 .207 169.714 .207 169.714 27.756 0 27.756"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-f",
    points: "1 .5 1.5 .5 1.5 1 1 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-h",
    points: "1 .5 1.5 .5 1.5 1 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ban_khar_v7-j",
    d: "M145.939799,62.5556921 C145.984302,61.6062629 146.013705,60.6544541 146.013705,59.6986794 C146.013705,25.6508923 117.537623,0.952247191 85.0269061,0.952247191 C52.516189,0.952247191 24.1418269,24.9965238 24.1418269,59.0443108 C24.1418269,60.2316923 24.1847401,61.4151079 24.2530833,62.5945577 C24.1863295,62.5985235 24.1418269,62.6016962 24.1418269,62.6016962 C24.2101702,63.006215 24.2785134,63.4107337 24.3468566,63.8152524 C24.6464543,67.6764235 25.2925362,71.4836587 26.2700034,75.1925403 C29.2747216,92.9707423 32.2794398,110.748944 35.284158,128.527146 C37.0706183,139.095397 43.5417689,147.076313 52.1776516,154.237881 C56.5301619,157.847616 61.3205458,161.105975 66.6084048,163.480738 C67.9267934,164.073239 71.2899162,165.483502 74.7031044,166.490833 L74.7031044,166.493213 C74.7031044,166.493213 75.516071,166.770031 76.9520736,167.082541 C77.7030545,167.25466 78.4309894,167.392672 79.1191899,167.482301 C82.0595383,167.935996 86.2626471,168.23423 91.103891,167.543375 C92.3769824,167.425192 93.8217266,167.118234 95.2942848,166.713715 C97.0656461,166.262399 98.8894568,165.672278 100.74426,164.896554 C100.74426,164.896554 100.74426,164.896554 100.74426,164.896554 C102.25258,164.317537 103.48991,163.78849 104.174932,163.480738 C109.461996,161.105975 114.25238,157.847616 118.605685,154.237881 C127.241568,147.076313 133.712718,139.095397 135.498384,128.527146 C139.212759,106.552261 142.225424,84.5305778 145.939799,62.5556921 C145.939799,62.5556921 146.394361,62.5858328 145.939799,62.5556921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-l",
    points: "0 .16 116.657 .16 116.657 48.28 0 48.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-n",
    points: "0 .561 46.319 .561 46.319 43.203 0 43.203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ban_khar_v7-p",
    points: ".892 .533 47.211 .533 47.211 43.175 .892 43.175"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(21 12)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ban_khar_v7-b)",
    xlinkHref: "#ban_khar_v7-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7FA",
    stroke: "#DEDEDE",
    strokeWidth: 4,
    xlinkHref: "#ban_khar_v7-a"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ban_khar_v7-c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.858 5.048)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.142 146.952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 .793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B72026",
    d: "M85.454,0.2067 L84.261,0.2067 L0,0.2067 L1.093,2.3367 C9.911,12.2667 20.467,20.6167 32.286,26.9117 C34.102,26.0547 38.469,23.9947 41.655,22.4927 C43.752,21.5037 45.337,20.7567 45.338,20.7557 C44.799,20.9217 43.567,20.1567 42.176,19.0817 C39.442,16.9677 36.081,13.6277 36.081,13.6277 C36.671,8.2687 41.21,0.5017 41.21,0.5017 L49.982,0.5017 C53.627,0.5007 57.024,0.5007 57.024,0.5007 C56.964,0.7837 56.913,1.0787 56.861,1.3717 L74.455,0.5007 L84.757,4.8117 L84.937,4.8217 L95.259,0.5007 L110.432,1.2527 C110.386,1.0007 110.343,0.7447 110.29,0.5007 C110.29,0.5007 113.969,0.5007 117.778,0.5017 L117.778,0.5007 L117.778,0.5017 L126.107,0.5017 C126.107,0.5017 127.886,3.5457 129.362,7.1377 L130.401,7.1907 L130.453,10.1427 C130.828,11.3467 131.117,12.5367 131.236,13.6277 C131.236,13.6277 130.969,13.8937 130.526,14.3197 C128.592,16.1867 123.282,21.1547 121.979,20.7557 C121.981,20.7567 126.759,23.0097 130.712,24.8747 C133.5,26.1897 135.879,27.3117 135.879,27.3117 C135.868,27.4547 135.847,27.6067 135.829,27.7557 C148.297,21.3717 159.406,12.7137 168.622,2.3367 L169.714,0.2067 L85.454,0.2067 Z",
    mask: "url(#ban_khar_v7-e)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B72026",
    d: "M131.4008,7.9844 L130.3618,7.9304 C130.7628,8.9084 131.1378,9.9264 131.4528,10.9354 L131.4008,7.9844 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B72026",
    points: "85.937 5.615 85.757 5.605 85.858 5.648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M76.1328 38.541L77.8248 33.261 78.4288 31.366 80.0558 26.291 80.3528 25.3 81.0078 23.103 80.7868 22.594 78.6048 17.559 77.8338 15.788 77.1888 14.301 61.2978 28.444C62.9198 32.018 64.6998 35.648 66.6118 39.14 69.5568 39.65 72.5428 40.042 75.5618 40.317L76.1328 38.541zM93.2875 15.249L89.7505 23.059 89.7425 23.079 92.9575 33.673 92.9815 33.691 93.9025 36.77 94.2535 37.943 94.3165 38.149 94.3155 38.149 94.9945 40.421C97.9145 40.185 100.8015 39.836 103.6535 39.38 105.7685 35.483 107.6885 31.452 109.3935 27.533L93.9495 13.787 93.2875 15.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D02729",
    d: "M78.6049,17.5586 L80.7869,22.5936 L81.0069,23.1036 L80.3529,25.2996 L80.0559,26.2906 L78.4289,31.3666 L77.8249,33.2606 L76.1329,38.5406 L75.5619,40.3176 C78.9529,40.6266 82.3859,40.7926 85.8569,40.7926 C88.9339,40.7926 91.9809,40.6636 94.9949,40.4206 L94.3159,38.1496 L94.3169,38.1496 L94.2529,37.9436 L93.9029,36.7706 L92.9819,33.6916 L92.9579,33.6726 L89.7429,23.0796 L89.7509,23.0586 L93.2879,15.2486 L93.9499,13.7876 L85.8579,6.5846 L77.1879,14.3006 L77.8339,15.7876 L78.6049,17.5586 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 39.793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C2BDBB",
    mask: "url(#ban_khar_v7-g)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C2BDBB",
    d: "M61.2973,28.4444 L60.0503,29.5544 C60.6623,32.3984 61.3593,35.3124 62.1233,38.2644 C63.6093,38.5864 65.1053,38.8794 66.6113,39.1394 C64.6993,35.6484 62.9203,32.0174 61.2973,28.4444"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 39.793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A3",
    mask: "url(#ban_khar_v7-i)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A3",
    d: "M109.394,27.5332 C107.689,31.4522 105.769,35.4832 103.654,39.3802 C104.796,39.1982 105.932,38.9962 107.063,38.7792 C108.042,35.0242 108.915,31.3282 109.645,27.7562 L109.394,27.5332 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M109.394,27.5332 C109.581,27.1022 109.766,26.6752 109.948,26.2482 C109.951,26.2312 109.954,26.2162 109.957,26.1992 L94.281,13.0582 L93.95,13.7872 L109.394,27.5332 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CACA",
    d: "M109.394,27.5332 C109.581,27.1022 109.766,26.6752 109.948,26.2482 C109.951,26.2312 109.954,26.2162 109.957,26.1992 L94.281,13.0582 L93.95,13.7872 L109.394,27.5332 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M61.2973,28.4444 L77.1883,14.3004 L76.8593,13.5424 L60.6913,27.0944 C60.8903,27.5434 61.0923,27.9934 61.2973,28.4444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CACA",
    d: "M61.2973,28.4444 L77.1883,14.3004 L76.8593,13.5424 L60.6913,27.0944 C60.8903,27.5434 61.0923,27.9934 61.2973,28.4444"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D02729",
    points: "85.858 6.585 93.95 13.787 94.281 13.059 85.858 5.998 76.859 13.542 77.189 14.301"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5CACA",
    points: "85.858 6.585 93.95 13.787 94.281 13.059 85.858 5.998 76.859 13.542 77.189 14.301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2BDBB",
    d: "M60.6909,27.0948 L59.7059,27.9208 C59.8169,28.4618 59.9329,29.0068 60.0499,29.5548 L61.2969,28.4448 C61.0929,27.9928 60.8909,27.5428 60.6909,27.0948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CACA",
    d: "M60.6909,27.0948 L59.7059,27.9208 C59.8169,28.4618 59.9329,29.0068 60.0499,29.5548 L61.2969,28.4448 C61.0929,27.9928 60.8909,27.5428 60.6909,27.0948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9A5A3",
    d: "M109.394,27.5332 L109.645,27.7562 C109.748,27.2512 109.851,26.7472 109.948,26.2482 C109.766,26.6752 109.581,27.1022 109.394,27.5332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CACA",
    d: "M109.394,27.5332 L109.645,27.7562 C109.748,27.2512 109.851,26.7472 109.948,26.2482 C109.766,26.6752 109.581,27.1022 109.394,27.5332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M111.4321,2.0459 L96.2591,1.2949 L111.6011,3.0759 C111.5501,2.7259 111.4941,2.3829 111.4321,2.0459"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "85.757 5.606 75.455 1.294 84.891 5.561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M75.455,1.2949 L57.861,2.1649 C57.792,2.5539 57.731,2.9529 57.676,3.3589 L75.455,1.2949 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "96.259 1.295 85.937 5.615 86.625 5.651"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "85.306 5.748 86.41 5.748 86.625 5.651 85.937 5.615 85.858 5.648 85.757 5.605 84.891 5.561"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "86.41 5.748 85.306 5.748 85.858 5.998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M88.4916 5.7481L90.7596 5.7481 93.8046 5.7481 93.9176 5.7481 111.8736 5.7481C111.8146 4.8181 111.7226 3.9291 111.6006 3.0761L96.2596 1.2951 86.6246 5.6511 88.4916 5.7481zM57.5781 4.1377L84.8911 5.5607 75.4551 1.2947 57.6761 3.3597C57.6411 3.6167 57.6071 3.8727 57.5781 4.1377"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "86.625 5.651 86.41 5.748 88.492 5.748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M76.7304 5.7481L79.0444 5.7481 82.0904 5.7481 85.3064 5.7481 84.8914 5.5611 57.5784 4.1381C57.5214 4.6601 57.4774 5.1991 57.4424 5.7481L76.7304 5.7481zM111.937 6.9697C111.922 6.5547 111.9 6.1507 111.874 5.7477L93.917 5.7477C94.039 5.8437 94.156 5.9487 94.275 6.0497L111.937 6.9697z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M111.937 6.9697L94.275 6.0497C95.027 6.6877 95.75 7.4337 96.443 8.2967L94.941 11.6017 94.281 13.0587 109.958 26.1997C111.352 19.0287 112.124 12.4207 111.937 6.9697M58.6723 22.4053C59.3123 23.9393 59.9843 25.5083 60.6913 27.0943L76.8593 13.5423 75.6503 10.7523 74.8823 8.9853 74.3843 7.8423C75.1563 7.0383 75.9383 6.3373 76.7303 5.7483L57.4423 5.7483C57.1413 10.4773 57.6303 16.1693 58.6723 22.4053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M74.8823,8.9854 L79.0453,5.7484 L76.7303,5.7484 C75.9383,6.3374 75.1563,7.0384 74.3843,7.8414 L74.8823,8.9854 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "75.65 10.752 82.09 5.748 79.045 5.748 74.882 8.985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M93.9174,5.7481 L93.8054,5.7481 L90.7594,5.7481 L88.4914,5.7481 L94.2744,6.0501 C94.1554,5.9491 94.0384,5.8441 93.9174,5.7481"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M94.2807,13.0586 L94.9407,11.6016 L96.4427,8.2966 C95.7507,7.4336 95.0267,6.6876 94.2747,6.0496 L88.4917,5.7476 L86.4097,5.7476 L85.8577,5.9976 L94.2807,13.0586 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "75.65 10.752 76.859 13.542 85.858 5.998 85.306 5.748 82.09 5.748"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    points: "82.09 5.748 82.09 5.748 75.65 10.752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M59.706,27.9209 L60.691,27.0949 C59.985,25.5079 59.312,23.9399 58.672,22.4049 C58.973,24.2009 59.32,26.0449 59.706,27.9209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B1C29",
    d: "M60.0502 29.5547C59.9322 29.0067 59.8172 28.4617 59.7062 27.9207 59.3202 26.0447 58.9722 24.2007 58.6722 22.4057 57.6302 16.1687 57.1412 10.4777 57.4422 5.7477 57.4772 5.1997 57.5212 4.6597 57.5782 4.1377 57.6072 3.8727 57.6412 3.6167 57.6762 3.3597 57.7312 2.9527 57.7922 2.5537 57.8612 2.1647 57.9132 1.8717 57.9642 1.5767 58.0242 1.2937 58.0242 1.2937 54.6272 1.2937 50.9822 1.2947L42.2102 1.2947C42.2102 1.2947 37.6712 9.0617 37.0812 14.4207 37.0812 14.4207 40.4422 17.7607 43.1762 19.8747 44.5672 20.9507 45.7992 21.7147 46.3382 21.5487 46.3372 21.5497 44.7522 22.2967 42.6542 23.2857 39.4682 24.7877 35.1022 26.8477 33.2852 27.7047 35.9232 29.1107 38.6242 30.4117 41.3832 31.6077 44.2262 32.8387 47.1292 33.9607 50.0892 34.9577 51.5062 35.4357 52.9372 35.8797 54.3792 36.3017 56.9242 37.0457 59.5072 37.7007 62.1232 38.2647 61.3602 35.3127 60.6622 32.3987 60.0502 29.5547M109.9575 26.1992C109.9535 26.2162 109.9505 26.2312 109.9475 26.2482 109.9535 26.2342 109.9595 26.2202 109.9655 26.2062L109.9575 26.1992zM123.811 7.5889L123.727 7.5839C123.745 7.6069 123.762 7.6299 123.78 7.6509L123.811 7.5889zM117.017 7.1514C117.008 7.1774 116.998 7.2064 116.991 7.2334L117.044 7.2364C117.036 7.2084 117.026 7.1794 117.017 7.1514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B1C29",
    d: "M131.7127,25.6684 C127.7597,23.8024 122.9807,21.5494 122.9787,21.5484 C124.2817,21.9484 129.5927,16.9794 131.5257,15.1134 C131.9697,14.6864 132.2357,14.4214 132.2357,14.4214 C132.1167,13.3304 131.8277,12.1394 131.4527,10.9354 C131.1377,9.9264 130.7627,8.9084 130.3617,7.9304 C128.8867,4.3384 127.1067,1.2954 127.1067,1.2954 L118.7777,1.2954 C114.9697,1.2944 111.2907,1.2944 111.2907,1.2944 C111.3437,1.5384 111.3867,1.7944 111.4317,2.0464 C111.4937,2.3814 111.5507,2.7254 111.6007,3.0764 C111.7227,3.9284 111.8147,4.8184 111.8737,5.7484 C111.8997,6.1494 111.9227,6.5544 111.9367,6.9694 C112.1247,12.4214 111.3517,19.0284 109.9577,26.1994 L109.9657,26.2064 C109.9597,26.2204 109.9537,26.2344 109.9477,26.2484 C109.8507,26.7474 109.7487,27.2514 109.6447,27.7554 C108.9147,31.3284 108.0427,35.0244 107.0627,38.7794 C109.7307,38.2684 112.3657,37.6624 114.9647,36.9644 C117.1397,36.3804 119.2917,35.7374 121.4127,35.0274 C124.9597,33.8404 128.4277,32.4844 131.8047,30.9634 C133.5027,30.1984 135.1777,29.3944 136.8287,28.5484 C136.8467,28.4004 136.8677,28.2484 136.8797,28.1054 C136.8797,28.1054 134.5007,26.9834 131.7127,25.6684 Z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-j"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#262322",
    xlinkHref: "#ban_khar_v7-j"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ban_khar_v7-k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.858 -25.048)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M95,186 L95,202.483697 C95,214.721484 83.5,219 83.5,219 C83.5,219 72,214.717861 72,202.483697 L72,186 L95,186 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M95,186.007298 L95,202.560155 C95,213.996807 84.5,218 84.5,218 C84.5,218 74,213.985859 74,202.560155 L74,186 L95,186 L95,186.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,186 L117,202.483697 C117,214.721484 105.5,219 105.5,219 C105.5,219 94,214.717861 94,202.483697 L94,186 L117,186 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M116,186.007298 L116,202.560155 C116,213.996807 105.5,218 105.5,218 C105.5,218 95,213.985859 95,202.560155 L95,186 L116,186 L116,186.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,186 L139,202.483697 C139,214.721484 127.5,219 127.5,219 C127.5,219 116,214.717861 116,202.483697 L116,186 L139,186 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M138 186.007298L138 202.560155C138 213.996807 127.5 218 127.5 218 127.5 218 117 213.985859 117 202.560155L117 186 138 186 138 186.007298zM63 173L63 189.560155C63 200.996807 52.5 205 52.5 205 52.5 205 42 200.985859 42 189.560155L42 173 63 173z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,173 L85,189.481888 C85,201.718332 73.5,206 73.5,206 C73.5,206 62,201.718332 62,189.481888 L62,173 L85,173 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M84,173 L84,189.560155 C84,200.996807 73.5,205 73.5,205 C73.5,205 63,200.985859 63,189.560155 L63,173 L84,173 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,173 L107,189.481888 C107,201.718332 95.5,206 95.5,206 C95.5,206 84,201.718332 84,189.481888 L84,173 L107,173 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M106,173 L106,189.560155 C106,200.996807 95.5,205 95.5,205 C95.5,205 85,200.985859 85,189.560155 L85,173 L106,173 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,173 L129,189.481888 C129,201.718332 117.5,206 117.5,206 C117.5,206 106,201.718332 106,189.481888 L106,173 L129,173 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M127,173 L127,189.560155 C127,200.996807 116.5,205 116.5,205 C116.5,205 106,200.985859 106,189.560155 L106,173 L127,173 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M149,173 L149,189.481888 C149,201.718332 137.5,206 137.5,206 C137.5,206 126,201.718332 126,189.481888 L126,173 L149,173 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M147,173 L147,189.560155 C147,200.996807 136.5,205 136.5,205 C136.5,205 126,200.985859 126,189.560155 L126,173 L147,173 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M76,159 L76,175.483697 C76,187.721484 64.5,192 64.5,192 C64.5,192 53,187.717861 53,175.483697 L53,159 L76,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M75,159.007298 L75,175.560155 C75,186.996807 64.5,191 64.5,191 C64.5,191 54,186.985859 54,175.560155 L54,159 L75,159 L75,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M96,159 L96,175.483697 C96,187.721484 84.5,192 84.5,192 C84.5,192 73,187.717861 73,175.483697 L73,159 L96,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M96,159.007298 L96,175.560155 C96,186.996807 85.5,191 85.5,191 C85.5,191 75,186.985859 75,175.560155 L75,159 L96,159 L96,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M118,159 L118,175.483697 C118,187.721484 106.5,192 106.5,192 C106.5,192 95,187.717861 95,175.483697 L95,159 L118,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,159.007298 L117,175.560155 C117,186.996807 106.5,191 106.5,191 C106.5,191 96,186.985859 96,175.560155 L96,159 L117,159 L117,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M140,159 L140,175.483697 C140,187.721484 128.5,192 128.5,192 C128.5,192 117,187.717861 117,175.483697 L117,159 L140,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M139,159.007298 L139,175.560155 C139,186.996807 128.5,191 128.5,191 C128.5,191 118,186.985859 118,175.560155 L118,159 L139,159 L139,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,159 L161,175.483697 C161,187.721484 149.5,192 149.5,192 C149.5,192 138,187.717861 138,175.483697 L138,159 L161,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M159,159.007298 L159,175.560155 C159,186.996807 148.5,191 148.5,191 C148.5,191 138,186.985859 138,175.560155 L138,159 L159,159 L159,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,159 L182,175.483697 C182,187.721484 170.5,192 170.5,192 C170.5,192 159,187.717861 159,175.483697 L159,159 L182,159 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M181,159.007298 L181,175.560155 C181,186.996807 170.5,191 170.5,191 C170.5,191 160,186.985859 160,175.560155 L160,159 L181,159 L181,159.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M23,146 L23,162.481888 C23,174.718332 11.5,179 11.5,179 C11.5,179 0,174.718332 0,162.481888 L0,146 L23,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M21,146 L21,162.560155 C21,173.996807 10.5,178 10.5,178 C10.5,178 0,173.985859 0,162.560155 L0,146 L21,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,146 L44,162.481888 C44,174.718332 32.5,179 32.5,179 C32.5,179 21,174.718332 21,162.481888 L21,146 L44,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M44,146 L44,162.560155 C44,173.996807 33.5,178 33.5,178 C33.5,178 23,173.985859 23,162.560155 L23,146 L44,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M64,146 L64,162.481888 C64,174.718332 52.5,179 52.5,179 C52.5,179 41,174.718332 41,162.481888 L41,146 L64,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M64,146 L64,162.560155 C64,173.996807 53.5,178 53.5,178 C53.5,178 43,173.985859 43,162.560155 L43,146 L64,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M86,146 L86,162.481888 C86,174.718332 74.5,179 74.5,179 C74.5,179 63,174.718332 63,162.481888 L63,146 L86,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M85,146 L85,162.560155 C85,173.996807 74.5,178 74.5,178 C74.5,178 64,173.985859 64,162.560155 L64,146 L85,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M108,146 L108,162.481888 C108,174.718332 96.5,179 96.5,179 C96.5,179 85,174.718332 85,162.481888 L85,146 L108,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M107,146 L107,162.560155 C107,173.996807 96.5,178 96.5,178 C96.5,178 86,173.985859 86,162.560155 L86,146 L107,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M130,146 L130,162.481888 C130,174.718332 118.5,179 118.5,179 C118.5,179 107,174.718332 107,162.481888 L107,146 L130,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M128,146 L128,162.560155 C128,173.996807 117.5,178 117.5,178 C117.5,178 107,173.985859 107,162.560155 L107,146 L128,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M150,146 L150,162.481888 C150,174.718332 138.5,179 138.5,179 C138.5,179 127,174.718332 127,162.481888 L127,146 L150,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M148,146 L148,162.560155 C148,173.996807 137.5,178 137.5,178 C137.5,178 127,173.985859 127,162.560155 L127,146 L148,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,146 L171,162.481888 C171,174.718332 159.5,179 159.5,179 C159.5,179 148,174.718332 148,162.481888 L148,146 L171,146 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M170,146 L170,162.560155 C170,173.996807 159.5,178 159.5,178 C159.5,178 149,173.985859 149,162.560155 L149,146 L170,146 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,133 L54,149.483697 C54,161.721484 42.5,166 42.5,166 C42.5,166 31,161.717861 31,149.483697 L31,133 L54,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M54,133.007298 L54,149.560155 C54,160.996807 43.5,165 43.5,165 C43.5,165 33,160.985859 33,149.560155 L33,133 L54,133 L54,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,133 L75,149.483697 C75,161.721484 63.5,166 63.5,166 C63.5,166 52,161.717861 52,149.483697 L52,133 L75,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M74,133.007298 L74,149.560155 C74,160.996807 63.5,165 63.5,165 C63.5,165 53,160.985859 53,149.560155 L53,133 L74,133 L74,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,133 L97,149.483697 C97,161.721484 85.5,166 85.5,166 C85.5,166 74,161.717861 74,149.483697 L74,133 L97,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M96,133.007298 L96,149.560155 C96,160.996807 85.5,165 85.5,165 C85.5,165 75,160.985859 75,149.560155 L75,133 L96,133 L96,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,133 L117,149.483697 C117,161.721484 105.5,166 105.5,166 C105.5,166 94,161.717861 94,149.483697 L94,133 L117,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,133.007298 L117,149.560155 C117,160.996807 106.5,165 106.5,165 C106.5,165 96,160.985859 96,149.560155 L96,133 L117,133 L117,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,133 L139,149.483697 C139,161.721484 127.5,166 127.5,166 C127.5,166 116,161.717861 116,149.483697 L116,133 L139,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M138,133.007298 L138,149.560155 C138,160.996807 127.5,165 127.5,165 C127.5,165 117,160.985859 117,149.560155 L117,133 L138,133 L138,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,133 L161,149.483697 C161,161.721484 149.5,166 149.5,166 C149.5,166 138,161.717861 138,149.483697 L138,133 L161,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M160,133.007298 L160,149.560155 C160,160.996807 149.5,165 149.5,165 C149.5,165 139,160.985859 139,149.560155 L139,133 L160,133 L160,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,133 L182,149.483697 C182,161.721484 170.5,166 170.5,166 C170.5,166 159,161.717861 159,149.483697 L159,133 L182,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M180,133.007298 L180,149.560155 C180,160.996807 169.5,165 169.5,165 C169.5,165 159,160.985859 159,149.560155 L159,133 L180,133 L180,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M203,133 L203,149.483697 C203,161.721484 191.5,166 191.5,166 C191.5,166 180,161.717861 180,149.483697 L180,133 L203,133 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M202,133.007298 L202,149.560155 C202,160.996807 191.5,165 191.5,165 C191.5,165 181,160.985859 181,149.560155 L181,133 L202,133 L202,133.007298 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,120 L44,136.481888 C44,148.718332 32.5,153 32.5,153 C32.5,153 21,148.718332 21,136.481888 L21,120 L44,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M42,120 L42,136.560155 C42,147.996807 31.5,152 31.5,152 C31.5,152 21,147.985859 21,136.560155 L21,120 L42,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M65,120 L65,136.481888 C65,148.718332 53.5,153 53.5,153 C53.5,153 42,148.718332 42,136.481888 L42,120 L65,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M65,120 L65,136.560155 C65,147.996807 54.5,152 54.5,152 C54.5,152 44,147.985859 44,136.560155 L44,120 L65,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,120 L85,136.481888 C85,148.718332 73.5,153 73.5,153 C73.5,153 62,148.718332 62,136.481888 L62,120 L85,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M85,120 L85,136.560155 C85,147.996807 74.5,152 74.5,152 C74.5,152 64,147.985859 64,136.560155 L64,120 L85,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,120 L107,136.481888 C107,148.718332 95.5,153 95.5,153 C95.5,153 84,148.718332 84,136.481888 L84,120 L107,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M106,120 L106,136.560155 C106,147.996807 95.5,152 95.5,152 C95.5,152 85,147.985859 85,136.560155 L85,120 L106,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,120 L129,136.481888 C129,148.718332 117.5,153 117.5,153 C117.5,153 106,148.718332 106,136.481888 L106,120 L129,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M128,120 L128,136.560155 C128,147.996807 117.5,152 117.5,152 C117.5,152 107,147.985859 107,136.560155 L107,120 L128,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M151,120 L151,136.481888 C151,148.718332 139.5,153 139.5,153 C139.5,153 128,148.718332 128,136.481888 L128,120 L151,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M149,120 L149,136.560155 C149,147.996807 138.5,152 138.5,152 C138.5,152 128,147.985859 128,136.560155 L128,120 L149,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,120 L171,136.481888 C171,148.718332 159.5,153 159.5,153 C159.5,153 148,148.718332 148,136.481888 L148,120 L171,120 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M169,120 L169,136.560155 C169,147.996807 158.5,152 158.5,152 C158.5,152 148,147.985859 148,136.560155 L148,120 L169,120 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,106 L54,122.483697 C54,134.721484 42.5,139 42.5,139 C42.5,139 31,134.717861 31,122.483697 L31,106 L54,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M54,107 L54,123.560155 C54,134.996807 43.5,139 43.5,139 C43.5,139 33,134.985859 33,123.560155 L33,107 L54,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,106 L75,122.483697 C75,134.721484 63.5,139 63.5,139 C63.5,139 52,134.717861 52,122.483697 L52,106 L75,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M74,107 L74,123.560155 C74,134.996807 63.5,139 63.5,139 C63.5,139 53,134.985859 53,123.560155 L53,107 L74,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,106 L97,122.483697 C97,134.721484 85.5,139 85.5,139 C85.5,139 74,134.717861 74,122.483697 L74,106 L97,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M96,107 L96,123.560155 C96,134.996807 85.5,139 85.5,139 C85.5,139 75,134.985859 75,123.560155 L75,107 L96,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,106 L117,122.483697 C117,134.721484 105.5,139 105.5,139 C105.5,139 94,134.717861 94,122.483697 L94,106 L117,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,107 L117,123.560155 C117,134.996807 106.5,139 106.5,139 C106.5,139 96,134.985859 96,123.560155 L96,107 L117,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,106 L139,122.483697 C139,134.721484 127.5,139 127.5,139 C127.5,139 116,134.717861 116,122.483697 L116,106 L139,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A724A",
    d: "M138,107 L138,123.560155 C138,134.996807 127.5,139 127.5,139 C127.5,139 117,134.985859 117,123.560155 L117,107 L138,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,106 L161,122.483697 C161,134.721484 149.5,139 149.5,139 C149.5,139 138,134.717861 138,122.483697 L138,106 L161,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M160,107 L160,123.560155 C160,134.996807 149.5,139 149.5,139 C149.5,139 139,134.985859 139,123.560155 L139,107 L160,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,106 L182,122.483697 C182,134.721484 170.5,139 170.5,139 C170.5,139 159,134.717861 159,122.483697 L159,106 L182,106 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M180,107 L180,123.560155 C180,134.996807 169.5,139 169.5,139 C169.5,139 159,134.985859 159,123.560155 L159,107 L180,107 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,93 L44,109.487323 C44,121.722423 32.5,126 32.5,126 C32.5,126 21,121.718801 21,109.487323 L21,93.007244 L44,93.007244 L44,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M42,93 L42,109.560155 C42,120.996807 31.5,125 31.5,125 C31.5,125 21,120.985859 21,109.560155 L21,93 L42,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M65,93 L65,109.487323 C65,121.722423 53.5,126 53.5,126 C53.5,126 42,121.718801 42,109.487323 L42,93.007244 L65,93.007244 L65,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M65,93 L65,109.560155 C65,120.996807 54.5,125 54.5,125 C54.5,125 44,120.985859 44,109.560155 L44,93 L65,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,93 L85,109.487323 C85,121.722423 73.5,126 73.5,126 C73.5,126 62,121.718801 62,109.487323 L62,93.007244 L85,93.007244 L85,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M85,93 L85,109.560155 C85,120.996807 74.5,125 74.5,125 C74.5,125 64,120.985859 64,109.560155 L64,93 L85,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,93 L107,109.487323 C107,121.722423 95.5,126 95.5,126 C95.5,126 84,121.718801 84,109.487323 L84,93.007244 L107,93.007244 L107,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M106,93 L106,109.560155 C106,120.996807 95.5,125 95.5,125 C95.5,125 85,120.985859 85,109.560155 L85,93 L106,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,93 L129,109.487323 C129,121.722423 117.5,126 117.5,126 C117.5,126 106,121.718801 106,109.487323 L106,93.007244 L129,93.007244 L129,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A724A",
    d: "M128,93 L128,109.560155 C128,120.996807 117.5,125 117.5,125 C117.5,125 107,120.985859 107,109.560155 L107,93 L128,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M151,93 L151,109.487323 C151,121.722423 139.5,126 139.5,126 C139.5,126 128,121.718801 128,109.487323 L128,93.007244 L151,93.007244 L151,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A724A",
    d: "M149,93 L149,109.560155 C149,120.996807 138.5,125 138.5,125 C138.5,125 128,120.985859 128,109.560155 L128,93 L149,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,93 L171,109.487323 C171,121.722423 159.5,126 159.5,126 C159.5,126 148,121.718801 148,109.487323 L148,93.007244 L171,93.007244 L171,93 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M169,93 L169,109.560155 C169,120.996807 158.5,125 158.5,125 C158.5,125 148,120.985859 148,109.560155 L148,93 L169,93 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,80 L54,96.4836974 C54,108.721484 42.5,113 42.5,113 C42.5,113 31,108.717861 31,96.4836974 L31,80 L54,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M54,80 L54,96.5601551 C54,107.996807 43.5,112 43.5,112 C43.5,112 33,107.985859 33,96.5601551 L33,80 L54,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,80 L75,96.4836974 C75,108.721484 63.5,113 63.5,113 C63.5,113 52,108.717861 52,96.4836974 L52,80 L75,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M74,80 L74,96.5601551 C74,107.996807 63.5,112 63.5,112 C63.5,112 53,107.985859 53,96.5601551 L53,80 L74,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,80 L97,96.4836974 C97,108.721484 85.5,113 85.5,113 C85.5,113 74,108.717861 74,96.4836974 L74,80 L97,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M96,80 L96,96.5601551 C96,107.996807 85.5,112 85.5,112 C85.5,112 75,107.985859 75,96.5601551 L75,80 L96,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,80 L117,96.4836974 C117,108.721484 105.5,113 105.5,113 C105.5,113 94,108.717861 94,96.4836974 L94,80 L117,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,80 L117,96.5601551 C117,107.996807 106.5,112 106.5,112 C106.5,112 96,107.985859 96,96.5601551 L96,80 L117,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,80 L139,96.4836974 C139,108.721484 127.5,113 127.5,113 C127.5,113 116,108.717861 116,96.4836974 L116,80 L139,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A724A",
    d: "M138,80 L138,96.5601551 C138,107.996807 127.5,112 127.5,112 C127.5,112 117,107.985859 117,96.5601551 L117,80 L138,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,80 L161,96.4836974 C161,108.721484 149.5,113 149.5,113 C149.5,113 138,108.717861 138,96.4836974 L138,80 L161,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M160,80 L160,96.5601551 C160,107.996807 149.5,112 149.5,112 C149.5,112 139,107.985859 139,96.5601551 L139,80 L160,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,80 L182,96.4836974 C182,108.721484 170.5,113 170.5,113 C170.5,113 159,108.717861 159,96.4836974 L159,80 L182,80 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M180,80 L180,96.5601551 C180,107.996807 169.5,112 169.5,112 C169.5,112 159,107.985859 159,96.5601551 L159,80 L180,80 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,66 L44,82.481888 C44,94.7183315 32.5,99 32.5,99 C32.5,99 21,94.7183315 21,82.481888 L21,66 L44,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M42,66 L42,82.5601551 C42,93.9968069 31.5,98 31.5,98 C31.5,98 21,93.9858593 21,82.5601551 L21,66 L42,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M65,66 L65,82.481888 C65,94.7183315 53.5,99 53.5,99 C53.5,99 42,94.7183315 42,82.481888 L42,66 L65,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M65,66 L65,82.5601551 C65,93.9968069 54.5,98 54.5,98 C54.5,98 44,93.9858593 44,82.5601551 L44,66 L65,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,66 L85,82.481888 C85,94.7183315 73.5,99 73.5,99 C73.5,99 62,94.7183315 62,82.481888 L62,66 L85,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M85,66 L85,82.5601551 C85,93.9968069 74.5,98 74.5,98 C74.5,98 64,93.9858593 64,82.5601551 L64,66 L85,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,66 L107,82.481888 C107,94.7183315 95.5,99 95.5,99 C95.5,99 84,94.7183315 84,82.481888 L84,66 L107,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M106,66 L106,82.5601551 C106,93.9968069 95.5,98 95.5,98 C95.5,98 85,93.9858593 85,82.5601551 L85,66 L106,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,66 L129,82.481888 C129,94.7183315 117.5,99 117.5,99 C117.5,99 106,94.7183315 106,82.481888 L106,66 L129,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M128,66 L128,82.5601551 C128,93.9968069 117.5,98 117.5,98 C117.5,98 107,93.9858593 107,82.5601551 L107,66 L128,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M151,66 L151,82.481888 C151,94.7183315 139.5,99 139.5,99 C139.5,99 128,94.7183315 128,82.481888 L128,66 L151,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M149,66 L149,82.5601551 C149,93.9968069 138.5,98 138.5,98 C138.5,98 128,93.9858593 128,82.5601551 L128,66 L149,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,66 L171,82.481888 C171,94.7183315 159.5,99 159.5,99 C159.5,99 148,94.7183315 148,82.481888 L148,66 L171,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M169,66 L169,82.5601551 C169,93.9968069 158.5,98 158.5,98 C158.5,98 148,93.9858593 148,82.5601551 L148,66 L169,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M192,66 L192,82.481888 C192,94.7183315 180.5,99 180.5,99 C180.5,99 169,94.7183315 169,82.481888 L169,66 L192,66 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M191,66 L191,82.5601551 C191,93.9968069 180.5,98 180.5,98 C180.5,98 170,93.9858593 170,82.5601551 L170,66 L191,66 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M33,53 L33,69.481888 C33,81.7183315 21.5,86 21.5,86 C21.5,86 10,81.7183315 10,69.481888 L10,53 L33,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M32,53 L32,69.5601551 C32,80.9968069 21.5,85 21.5,85 C21.5,85 11,80.9858593 11,69.5601551 L11,53 L32,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,53 L54,69.481888 C54,81.7183315 42.5,86 42.5,86 C42.5,86 31,81.7183315 31,69.481888 L31,53 L54,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M54,53 L54,69.5601551 C54,80.9968069 43.5,85 43.5,85 C43.5,85 33,80.9858593 33,69.5601551 L33,53 L54,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,53 L75,69.481888 C75,81.7183315 63.5,86 63.5,86 C63.5,86 52,81.7183315 52,69.481888 L52,53 L75,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M74,53 L74,69.5601551 C74,80.9968069 63.5,85 63.5,85 C63.5,85 53,80.9858593 53,69.5601551 L53,53 L74,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,53 L97,69.481888 C97,81.7183315 85.5,86 85.5,86 C85.5,86 74,81.7183315 74,69.481888 L74,53 L97,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M96,53 L96,69.5601551 C96,80.9968069 85.5,85 85.5,85 C85.5,85 75,80.9858593 75,69.5601551 L75,53 L96,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,53 L117,69.481888 C117,81.7183315 105.5,86 105.5,86 C105.5,86 94,81.7183315 94,69.481888 L94,53 L117,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,53 L117,69.5601551 C117,80.9968069 106.5,85 106.5,85 C106.5,85 96,80.9858593 96,69.5601551 L96,53 L117,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,53 L139,69.481888 C139,81.7183315 127.5,86 127.5,86 C127.5,86 116,81.7183315 116,69.481888 L116,53 L139,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M138,53 L138,69.5601551 C138,80.9968069 127.5,85 127.5,85 C127.5,85 117,80.9858593 117,69.5601551 L117,53 L138,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,53 L161,69.481888 C161,81.7183315 149.5,86 149.5,86 C149.5,86 138,81.7183315 138,69.481888 L138,53 L161,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M160,53 L160,69.5601551 C160,80.9968069 149.5,85 149.5,85 C149.5,85 139,80.9858593 139,69.5601551 L139,53 L160,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,53 L182,69.481888 C182,81.7183315 170.5,86 170.5,86 C170.5,86 159,81.7183315 159,69.481888 L159,53 L182,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M180,53 L180,69.5601551 C180,80.9968069 169.5,85 169.5,85 C169.5,85 159,80.9858593 159,69.5601551 L159,53 L180,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M203,53 L203,69.481888 C203,81.7183315 191.5,86 191.5,86 C191.5,86 180,81.7183315 180,69.481888 L180,53 L203,53 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M202,53 L202,69.5601551 C202,80.9968069 191.5,85 191.5,85 C191.5,85 181,80.9858593 181,69.5601551 L181,53 L202,53 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,40 L44,56.4836974 C44,68.7214842 32.5,73 32.5,73 C32.5,73 21,68.7178615 21,56.4836974 L21,40 L44,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M42,40 L42,56.5654355 C42,67.998176 31.5,72 31.5,72 C31.5,72 21,67.9872321 21,56.5654355 L21,40.0109439 L42,40.0109439 L42,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M65,40 L65,56.4836974 C65,68.7214842 53.5,73 53.5,73 C53.5,73 42,68.7178615 42,56.4836974 L42,40 L65,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M65,40 L65,56.5654355 C65,67.998176 54.5,72 54.5,72 C54.5,72 44,67.9872321 44,56.5654355 L44,40.0109439 L65,40.0109439 L65,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,40 L85,56.4836974 C85,68.7214842 73.5,73 73.5,73 C73.5,73 62,68.7178615 62,56.4836974 L62,40 L85,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A724A",
    d: "M85,40 L85,56.5654355 C85,67.998176 74.5,72 74.5,72 C74.5,72 64,67.9872321 64,56.5654355 L64,40.0109439 L85,40.0109439 L85,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,40 L107,56.4836974 C107,68.7214842 95.5,73 95.5,73 C95.5,73 84,68.7178615 84,56.4836974 L84,40 L107,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M106,40 L106,56.5654355 C106,67.998176 95.5,72 95.5,72 C95.5,72 85,67.9872321 85,56.5654355 L85,40.0109439 L106,40.0109439 L106,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,40 L129,56.4836974 C129,68.7214842 117.5,73 117.5,73 C117.5,73 106,68.7178615 106,56.4836974 L106,40 L129,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M128,40 L128,56.5654355 C128,67.998176 117.5,72 117.5,72 C117.5,72 107,67.9872321 107,56.5654355 L107,40.0109439 L128,40.0109439 L128,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M151,40 L151,56.4836974 C151,68.7214842 139.5,73 139.5,73 C139.5,73 128,68.7178615 128,56.4836974 L128,40 L151,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M149,40 L149,56.5654355 C149,67.998176 138.5,72 138.5,72 C138.5,72 128,67.9872321 128,56.5654355 L128,40.0109439 L149,40.0109439 L149,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,40 L171,56.4836974 C171,68.7214842 159.5,73 159.5,73 C159.5,73 148,68.7178615 148,56.4836974 L148,40 L171,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M169,40 L169,56.5654355 C169,67.998176 158.5,72 158.5,72 C158.5,72 148,67.9872321 148,56.5654355 L148,40.0109439 L169,40.0109439 L169,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M192,40 L192,56.4836974 C192,68.7214842 180.5,73 180.5,73 C180.5,73 169,68.7178615 169,56.4836974 L169,40 L192,40 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M191,40 L191,56.5654355 C191,67.998176 180.5,72 180.5,72 C180.5,72 170,67.9872321 170,56.5654355 L170,40.0109439 L191,40.0109439 L191,40 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M33,27 L33,43.481888 C33,55.7183315 21.5,60 21.5,60 C21.5,60 10,55.7183315 10,43.481888 L10,27 L33,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M32,27 L32,43.5601551 C32,54.9968069 21.5,59 21.5,59 C21.5,59 11,54.9858593 11,43.5601551 L11,27 L32,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,27 L54,43.481888 C54,55.7183315 42.5,60 42.5,60 C42.5,60 31,55.7183315 31,43.481888 L31,27 L54,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M54,27 L54,43.5601551 C54,54.9968069 43.5,59 43.5,59 C43.5,59 33,54.9858593 33,43.5601551 L33,27 L54,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,27 L75,43.481888 C75,55.7183315 63.5,60 63.5,60 C63.5,60 52,55.7183315 52,43.481888 L52,27 L75,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M74,27 L74,43.5601551 C74,54.9968069 63.5,59 63.5,59 C63.5,59 53,54.9858593 53,43.5601551 L53,27 L74,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,27 L97,43.481888 C97,55.7183315 85.5,60 85.5,60 C85.5,60 74,55.7183315 74,43.481888 L74,27 L97,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M96,27 L96,43.5601551 C96,54.9968069 85.5,59 85.5,59 C85.5,59 75,54.9858593 75,43.5601551 L75,27 L96,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,27 L117,43.481888 C117,55.7183315 105.5,60 105.5,60 C105.5,60 94,55.7183315 94,43.481888 L94,27 L117,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,27 L117,43.5601551 C117,54.9968069 106.5,59 106.5,59 C106.5,59 96,54.9858593 96,43.5601551 L96,27 L117,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,27 L139,43.481888 C139,55.7183315 127.5,60 127.5,60 C127.5,60 116,55.7183315 116,43.481888 L116,27 L139,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M138,27 L138,43.5601551 C138,54.9968069 127.5,59 127.5,59 C127.5,59 117,54.9858593 117,43.5601551 L117,27 L138,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,27 L161,43.481888 C161,55.7183315 149.5,60 149.5,60 C149.5,60 138,55.7183315 138,43.481888 L138,27 L161,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M160,27 L160,43.5601551 C160,54.9968069 149.5,59 149.5,59 C149.5,59 139,54.9858593 139,43.5601551 L139,27 L160,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M182,27 L182,43.481888 C182,55.7183315 170.5,60 170.5,60 C170.5,60 159,55.7183315 159,43.481888 L159,27 L182,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M180,27 L180,43.5601551 C180,54.9968069 169.5,59 169.5,59 C169.5,59 159,54.9858593 159,43.5601551 L159,27 L180,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M203,27 L203,43.481888 C203,55.7183315 191.5,60 191.5,60 C191.5,60 180,55.7183315 180,43.481888 L180,27 L203,27 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M202,27 L202,43.5601551 C202,54.9968069 191.5,59 191.5,59 C191.5,59 181,54.9858593 181,43.5601551 L181,27 L202,27 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44,14 L44,30.481888 C44,42.7183315 32.5,47 32.5,47 C32.5,47 21,42.7183315 21,30.481888 L21,14 L44,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M42,14 L42,30.5601551 C42,41.9968069 31.5,46 31.5,46 C31.5,46 21,41.9858593 21,30.5601551 L21,14 L42,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M65,14 L65,30.481888 C65,42.7183315 53.5,47 53.5,47 C53.5,47 42,42.7183315 42,30.481888 L42,14 L65,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M65,14 L65,30.5601551 C65,41.9968069 54.5,46 54.5,46 C54.5,46 44,41.9858593 44,30.5601551 L44,14 L65,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M85,14 L85,30.481888 C85,42.7183315 73.5,47 73.5,47 C73.5,47 62,42.7183315 62,30.481888 L62,14 L85,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M85,14 L85,30.5601551 C85,41.9968069 74.5,46 74.5,46 C74.5,46 64,41.9858593 64,30.5601551 L64,14 L85,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M107,14 L107,30.481888 C107,42.7183315 95.5,47 95.5,47 C95.5,47 84,42.7183315 84,30.481888 L84,14 L107,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M106,14 L106,30.5601551 C106,41.9968069 95.5,46 95.5,46 C95.5,46 85,41.9858593 85,30.5601551 L85,14 L106,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M129,14 L129,30.481888 C129,42.7183315 117.5,47 117.5,47 C117.5,47 106,42.7183315 106,30.481888 L106,14 L129,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M128,14 L128,30.5601551 C128,41.9968069 117.5,46 117.5,46 C117.5,46 107,41.9858593 107,30.5601551 L107,14 L128,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M151,14 L151,30.481888 C151,42.7183315 139.5,47 139.5,47 C139.5,47 128,42.7183315 128,30.481888 L128,14 L151,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M149,14 L149,30.5601551 C149,41.9968069 138.5,46 138.5,46 C138.5,46 128,41.9858593 128,30.5601551 L128,14 L149,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M171,14 L171,30.481888 C171,42.7183315 159.5,47 159.5,47 C159.5,47 148,42.7183315 148,30.481888 L148,14 L171,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#A18357",
    d: "M169,14 L169,30.5601551 C169,41.9968069 158.5,46 158.5,46 C158.5,46 148,41.9858593 148,30.5601551 L148,14 L169,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M192,14 L192,30.481888 C192,42.7183315 180.5,47 180.5,47 C180.5,47 169,42.7183315 169,30.481888 L169,14 L192,14 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M191,14 L191,30.5601551 C191,41.9968069 180.5,46 180.5,46 C180.5,46 170,41.9858593 170,30.5601551 L170,14 L191,14 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M33,0 L33,16.481888 C33,28.7183315 21.5,33 21.5,33 C21.5,33 10,28.7183315 10,16.481888 L10,0 L33,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M32,0 L32,16.5601551 C32,27.9968069 21.5,32 21.5,32 C21.5,32 11,27.9858593 11,16.5601551 L11,0 L32,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54,0 L54,16.481888 C54,28.7183315 42.5,33 42.5,33 C42.5,33 31,28.7183315 31,16.481888 L31,0 L54,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M54,0 L54,16.5601551 C54,27.9968069 43.5,32 43.5,32 C43.5,32 33,27.9858593 33,16.5601551 L33,0 L54,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M75,0 L75,16.481888 C75,28.7183315 63.5,33 63.5,33 C63.5,33 52,28.7183315 52,16.481888 L52,0 L75,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M74,0 L74,16.5601551 C74,27.9968069 63.5,32 63.5,32 C63.5,32 53,27.9858593 53,16.5601551 L53,0 L74,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M97,0 L97,16.481888 C97,28.7183315 85.5,33 85.5,33 C85.5,33 74,28.7183315 74,16.481888 L74,0 L97,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M96,0 L96,16.5601551 C96,27.9968069 85.5,32 85.5,32 C85.5,32 75,27.9858593 75,16.5601551 L75,0 L96,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M117,0 L117,16.481888 C117,28.7183315 105.5,33 105.5,33 C105.5,33 94,28.7183315 94,16.481888 L94,0 L117,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M117,0 L117,16.5601551 C117,27.9968069 106.5,32 106.5,32 C106.5,32 96,27.9858593 96,16.5601551 L96,0 L117,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M139,0 L139,16.481888 C139,28.7183315 127.5,33 127.5,33 C127.5,33 116,28.7183315 116,16.481888 L116,0 L139,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M138,0 L138,16.5601551 C138,27.9968069 127.5,32 127.5,32 C127.5,32 117,27.9858593 117,16.5601551 L117,0 L138,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M161,0 L161,16.481888 C161,28.7183315 149.5,33 149.5,33 C149.5,33 138,28.7183315 138,16.481888 L138,0 L161,0 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#B99664",
    d: "M160,0 L160,16.5601551 C160,27.9968069 149.5,32 149.5,32 C149.5,32 139,27.9858593 139,16.5601551 L139,0 L160,0 Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.858 .048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-l"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#262221",
    d: "M116.6504,43.9481 C116.8004,43.9681 114.3504,34.4011 105.0024,21.1431 C101.2964,15.8881 99.7004,14.3841 95.2894,10.6941 C80.9844,-1.2709 60.5644,-2.5799 38.1974,4.4251 C38.1664,4.4351 38.1354,4.4481 38.1054,4.4591 C28.3844,8.0721 18.1134,13.8871 8.6724,5.9121 C8.6724,5.9121 8.8994,14.2301 13.5604,22.4311 L13.5474,22.4161 C1.1894,36.0501 0.0004,48.2801 0.0004,48.2801 C7.9574,33.0111 19.6734,30.1201 19.6734,30.1201 L19.6564,30.0971 C25.1404,35.0621 33.3544,38.6821 45.6714,38.2271 C49.8334,37.9321 54.0054,37.3151 58.0884,36.4751 C61.2284,35.8291 64.3624,34.9731 67.3894,33.9001 C74.6174,31.3381 78.4134,28.7181 86.2454,27.7411 C104.7524,25.4321 116.6504,43.9481 116.6504,43.9481",
    mask: "url(#ban_khar_v7-m)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 61.84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4C",
    d: "M0.2608,25.6414 C2.1638,37.2304 13.9578,44.9424 26.6048,42.8654 C39.2508,40.7884 47.9608,29.7114 46.0578,18.1224 C44.1558,6.5334 32.3608,-1.1776 19.7148,0.8984 C7.0678,2.9744 -1.6422,14.0524 0.2608,25.6414",
    mask: "url(#ban_khar_v7-o)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0ECEB",
    d: "M24.1558,95.0254 C31.9548,93.7454 37.3448,86.8894 36.1718,79.7434 C34.9978,72.5964 27.6988,67.8234 19.8998,69.1044 C12.1018,70.3844 6.7108,77.2404 7.8838,84.3874 C9.0568,91.5334 16.3578,96.3054 24.1558,95.0254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2626",
    d: "M23.4551,82.5674 C23.4551,88.0864 22.8161,92.5604 22.0281,92.5604 C21.2391,92.5604 20.6011,88.0864 20.6011,82.5674 C20.6011,77.0484 21.2391,72.5744 22.0281,72.5744 C22.8161,72.5744 23.4551,77.0484 23.4551,82.5674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957950",
    d: "M3.6568 72.6787C3.6568 72.6787 17.5368 61.1937 46.6178 82.5937 46.6178 82.5937 45.4388 63.8367 27.3548 61.8247 27.3548 61.8247 11.9458 59.4537 3.6568 72.6787M44.2676 91.9375C44.2676 91.9375 11.7806 113.4345.1326 82.0295.1326 82.0295-2.7064 102.1135 18.9866 105.7265 18.9866 105.7265 36.4546 108.0235 44.2676 91.9375"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 61.84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ban_khar_v7-q",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ban_khar_v7-p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4C",
    d: "M46.9502,25.6136 C45.0482,37.2016 33.2532,44.9136 20.6062,42.8376 C7.9602,40.7616 -0.7498,29.6836 1.1532,18.0946 C3.0552,6.5056 14.8502,-1.2064 27.4972,0.8706 C40.1432,2.9466 48.8532,14.0246 46.9502,25.6136",
    mask: "url(#ban_khar_v7-q)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0ECEB",
    d: "M94.0831,94.8291 C86.3851,93.5651 81.0651,86.7991 82.2241,79.7451 C83.3811,72.6911 90.5861,67.9801 98.2841,69.2441 C105.9811,70.5081 111.3021,77.2751 110.1441,84.3291 C108.9861,91.3831 101.7801,96.0931 94.0831,94.8291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2626",
    d: "M94.7749,82.5327 C94.7749,87.9797 95.4059,92.3957 96.1839,92.3957 C96.9619,92.3957 97.5919,87.9797 97.5919,82.5327 C97.5919,77.0857 96.9619,72.6697 96.1839,72.6697 C95.4059,72.6697 94.7749,77.0857 94.7749,82.5327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#957950",
    d: "M114.5547 72.6509C114.5547 72.6509 100.6747 61.1659 71.5937 82.5659 71.5937 82.5659 72.7717 63.8089 90.8567 61.7969 90.8567 61.7969 106.2657 59.4259 114.5547 72.6509M73.9439 91.9097C73.9439 91.9097 106.4309 113.4067 118.0789 82.0017 118.0789 82.0017 120.9179 102.0857 99.2249 105.6997 99.2249 105.6997 81.7559 107.9947 73.9439 91.9097"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBanKharAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ban-khar-avatar.d95238e7.svg";
export { ForwardRef as ReactComponent };